/* eslint-disable import/no-cycle */
import AxiosAPI from './AxiosAPI';
import utility from '../shared/utility';

let QL_ENDPOINT = null;
class AnalyticsApi extends AxiosAPI {
  sendQualifiedListening(eventData) {
    // getting api url path as feature flag variable for flexibility
    const optimizelyIsInitialized = utility.isOptimizelyInitialized();
    if (optimizelyIsInitialized) {
      const getVariableFromOptimizely = window && window.$optimizely && window.$optimizely.getVariable;
      if (!QL_ENDPOINT && getVariableFromOptimizely) {
        QL_ENDPOINT = getVariableFromOptimizely('qualified_listening', 'ql_api_path', 'String');
      }
    }
    const apiPath = QL_ENDPOINT || 'v1/events/listening-stats';
    return new Promise((resolve, reject) => {
      super.post(apiPath, eventData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  sendEventTracking(eventData) {
    return new Promise((resolve, reject) => {
      super.post('v1/events/analytics-events', eventData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default AnalyticsApi;
